import React from 'react';

import './SideBar.css';

export default () => (
    <div className="sidebar">
        <h3 className="sidebar_header">Sidebar</h3>
    </div>
);
